import Base from "./Base";

class Login extends Base {
  static validateLogin(body) {
    return this.sendRequest("/login/validate-login", "POST", {}, body);
  }
}

export default Login;